import styled from 'styled-components';

import { SCROLL_MOBILE, SCROLL_DESKTOP } from '~/src/common/components/Category/constants';
import { COLORS } from '~/src/common/theme';
import { media } from '~/src/common/theme/deprecated';

export const Root = styled.div`
  scroll-margin-top: ${SCROLL_MOBILE}px;
  ${media.XL` scroll-margin-top: ${SCROLL_DESKTOP}px; `}
`;

export const Content = styled.div`
  padding: 16px;
  border-radius: 4px;
  border: 1px solid ${COLORS.NEUTRAL_STROKE};

  & > div {
    margin-top: 16px;
    padding-top: 24px;
    border-top: 1px solid ${COLORS.NEUTRAL_STROKE};
  }

  & > h2 {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
  }
`;
